<template>
  <div>
    <ul class="itemList" :class="top?'top':''" v-if="data.length">
      <li class="title" v-if="!detail">
        <img :src="`./assets/img/titles/${day}.png`" alt="">
      </li>
      <li v-for="item in data" :key="item.number"
      :class="getClass(item)"
      :id="detail?'item'+item.number:''"
      :ref="'#item'+item.number"
      >
        <h3>
          {{date}}
        </h3>
        <div class="img">
          <img
          v-if="item['image-icon']"
          :src="`./assets/img/start/${item['image-icon']}`"
          alt=""
          class="start"
          >
          <img
          v-if="item['mark-1']=='特設会場'"
          :src="'./assets/img/ico_hall.png'"
          alt=""
          class="hall"
          >
          <img :src="`./assets/img/items/${item.image}`" alt="">
        </div>
        <div class="content">
          <div class="title" v-if="item['product-1a']">
            <div class="icon" v-if="item['icon-1']">
              {{item['icon-1']}}
            </div>
            <h4>
              {{item['product-1a']}} {{item['product-1b']}}
            </h4>
            <div class="price">
              {{item['price-1']}}
            </div>
          </div>
          <div class="title" v-if="item['product-2a']">
            <div class="icon" v-if="item['icon-2']">
              {{item['icon-2']}}
            </div>
            <h4>
              {{item['product-2a']}} {{item['product-2b']}}
            </h4>
            <div class="price">
              {{item['price-2']}}
            </div>
          </div>
          <div class="note" v-if="item.text" v-text="item.text"></div>
          <div class="shopInfo">
            <div class="text">
              <p class="place">
                {{item.floor}}／{{item.brand}}
              </p>
              {{item.genre}}<br>
              {{item.tel}}
            </div>
            <div class="icon"
            v-if="item['mark-2']||item['mark-3']||item['mark-4']"
            >
              <img
              v-if="item['mark-2']"
              :src="`./assets/img/entrance_${getIcon(item['mark-2'])}.png`"
              alt=""
              >
              <img
              v-if="item['mark-3']"
              :src="`./assets/img/entrance_${getIcon(item['mark-3'])}.png`"
              alt=""
              >
              <img
              v-if="item['mark-4']"
              :src="`./assets/img/entrance_${getIcon(item['mark-4'])}.png`"
              alt=""
              >
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'itemList',
  props: {
    data: Array,
    day: String,
    top: Boolean,
    detail: Boolean,
  },
  data(){
    return {
      days: {
        'day-1': '1/1(元日)',
        'day-2': '年内販売',
        'day-3': 'その他',
      },
      marks: [
        {
          key: '1F',
          icon: '1f',
        },
        {
          key: '4F',
          icon: '4f',
        },
        {
          key: 'A',
          icon: 'a',
        },
        {
          key: 'B',
          icon: 'b',
        },
        {
          key: 'B1',
          icon: 'b1',
        },
        {
          key: 'B2',
          icon: 'b2',
        },
        {
          key: 'C',
          icon: 'c',
        },
        {
          key: 'シネマ棟',
          icon: 'cinema',
        },
        {
          key: 'E',
          icon: 'e',
        },
        {
          key: 'F',
          icon: 'f',
        },
        {
          key: 'G',
          icon: 'g',
        },
        {
          key: 'H',
          icon: 'h',
        },
        {
          key: '優先入口',
          icon: 'priority',
        },
        {
          key: '整理券配布入口',
          icon: 'ticket',
        },
      ]
    }
  },
  methods: {
    getClass(item){
      return {
        'category-A': Boolean(item['category-A']),
        'category-B': Boolean(item['category-B']),
        'category-C': Boolean(item['category-C']),
        'category-D': Boolean(item['category-D']),
      }
    },
    getIcon(key){
      let m = this.marks.find(mark=>mark.key == key)
      return m && m.icon ? m.icon : null
    }
  },
  computed: {
    date(){
      return this.days[this.day]
    }
  }
}
</script>

<style lang="scss">
@import '../assets/css/common.scss';
.itemList {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  &::before,
  &::after {
    content: "";
    width: calc((100% - 10rem) / 3);
    height: 0;
    display: block;
    order: 99
  }
  &>li {
    width: calc((100% - 10rem) / 3);
    margin-bottom: 5rem;
    background: #fff;
    order: 1;
    @include SP {
      width: 100%;
      margin-bottom: 8rem;
    }
    &.category-A {
      background: #e2f4e9;
      .content {
        &::before {
          background: url('../assets/cate_fashion.png') right top / contain no-repeat;
        }
      }
    }
    &.category-B {
      background: #edf8fe;
      .content {
        &::before {
          background: url('../assets/cate_lifestyle.png') right top / contain no-repeat;
        }
      }
    }
    &.category-C {
      background: #ffefe0;
      .content {
        &::before {
          background: url('../assets/cate_gourmet.png') right top / contain no-repeat;
        }
      }
    }
    &.category-D {
      background: #f6e3ec;
      .content {
        &::before {
          background: url('../assets/cate_service.png') right top / contain no-repeat;
        }
      }
    }
    &.title {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #151e5f;
      padding: 2.5rem;
      position: relative;
      width: 100%;
      @include SP {
        padding: 3.5rem 0;
      }
      img {
        max-width: 26.4rem;
        @include SP {
          max-width: 30.9rem;
        }
      }
      &::after {
        content: "";
        position: absolute;
        top: 99%;
        left: 0;
        right: 0;
        margin: auto;
        display: block;
        width: 5rem;
        height: 2.7rem;
        background: url('../assets/title_label.png') center top / contain no-repeat;
      }
    }
    h3 {
      height: 7.2rem;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #151e5f;
      font-size: 2rem;
      line-height: 1.5;
      @include SP {
        font-size: 4.2rem;
        height: auto;
        padding: 2.4rem 0;
      }
      .res {
        font-size: 1.6rem;
        color: #fff200;
        @include SP {
          font-size: 3rem;
        }
      }
    }
    .img {
      position: relative;
      img {
        display: block;
      }
      .link {
        &.top {
          display: none;
        }
      }
      .start {
        position: absolute;
        top: 2rem;
        left: 2rem;
        width: 31rem;
        z-index: 50;
        @include SP {
          width: 32rem;
        }
      }
      .hall {
        position: absolute;
        top: 1rem;
        right: 1rem;
        width: 7rem;
        z-index: 50;
        @include SP {
					right: 2rem;
					width: 7.4rem;
        }
      }
      .start + .hall {
        top: 6rem;
      }
    }
    .content {
      position: relative;
      padding: 5rem 2.4rem 4.5rem;
      @include SP {
        padding: 7.5rem 2rem;
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        display: block;
        width: 100%;
        height: 3.8rem;
        @include SP {
          height: 5rem;
        }
      }
      .title {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        line-height: 1.5;
        font-weight: bold;
        @include SP {
          font-size: 2.2rem;
        }
        .icon {
          border: .2rem solid #d6000f;
          color: #d6000f;
          padding: 0 .5em;
          margin-bottom: .8rem;
          @include SP {
            font-size: 2.2rem;
          }
        }
        h4 {
          font-size: 1.8rem;
          white-space: pre-line;
          @include SP {
            font-size: 2.6rem;
          }
        }
        .price {
          white-space: pre-line;
        }
        &+.title {
          margin-top: 1.6rem;
        }
      }
      .note {
        color: #d6000f;
        margin-top: 1em;
        line-height: 1.6;
        white-space: pre-line;
        @include SP {
          font-size: 2.2rem;
        }
      }
      .shopInfo {
        display: flex;
        margin-top: 1.6rem;
        font-size: 1.6rem;
        color: #555555;
        line-height: 1.8;
        @include SP {
          font-size: 2.2rem;
        }
        .text {
          width: 100%;
          .place {
            font-weight: bold;
          }
        }
        .icon {
          display: flex;
          justify-content: flex-end;
          align-items: flex-start;
          flex-wrap: wrap;
          margin-left: 4rem;
          max-width: 8rem;
          flex-shrink: 0;
          img {
            display: block;
            width: 3.5rem;
            margin: .25rem;
            @include SP {
              width: 4.8rem;
              margin: .5rem;
            }
          }
        }
      }
    }
  }
}
@include SP {
  .itemList.top {
    margin-bottom: 11rem;
    li:not(.title) {
      width: 48%;
      margin-bottom: 1rem;
      h3 {
        font-size: 2.7rem;
        height: 8.8rem;
        .res {
          font-size: 2rem;
        }
      }
      .img {
        /*.start {
          top: 1rem;
          left: 1.2rem;
          width: 9rem;
        }
        .hall {
          top: 1rem;
          right: 1rem;
          width: 7.4rem;
        }*/
      }
    }
    li.title {
      margin-bottom: 5rem;
    }
  }
}
</style>
